import { startOfMonth, subMonths } from 'date-fns'

export const formatISODate = isoDate => {
  if (!isoDate) {
    return ''
  }

  const date = new Date(isoDate)

  if (isNaN(date.getTime())) {
    return ''
  }

  return Intl.DateTimeFormat('fr').format(date)
}

export const monthFormatter = new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: 'short' })

export const getLastMonths = count => {
  const currentMonth = startOfMonth(new Date())

  return Array.from({ length: count }, (_, i) => subMonths(currentMonth, count - 1 - i))
}
